/* eslint-disable */
import session from './session';

export default {
    getTariffList(filter) {
        return session.get(`billing/tariff/${filter}`);
    },
    createTariff(data) {
        return session.post(`billing/tariff/`, data);
    },
    updateTariff(id, data) {
        return session.patch(`billing/tariff/${id}/`, data);
    },
    deleteTariff(id) {
        return session.delete(`billing/tariff/${id}/`);
    },
    getTransactionList(filter) {
        return session.get(`billing/transaction/${filter}`);
    },
    getInvoiceList(filter) {
        return session.get(`billing/invoice/${filter}`);
    },
    getInvoice(id) {
        return session.get(`billing/invoice/${id}/`);
    },
};
